import api from '../services/api';

/**
 * Envia um log de erro para o backend
 * @param {string} errorMessage - Mensagem de erro
 * @param {string} errorContext - Contexto onde o erro ocorreu
 * @param {Object} options - Opções adicionais
 * @param {string} options.errorDetails - Detalhes adicionais do erro
 * @param {string} options.clientId - ID do cliente
 * @param {string} options.url - URL onde o erro ocorreu
 */
export const logError = async (errorMessage, errorContext, options = {}) => {
  try {
    const errorData = {
      error_message: errorMessage,
      error_context: errorContext,
      error_details: options.errorDetails || '',
      client_id: options.clientId || '',
      url: options.url || window.location.href
    };

    await api.post('create_error_log', errorData);
  } catch (error) {
    // Não queremos mostrar erro para o usuário se o log falhar
    // Apenas logamos no console para debug
    console.error('Falha ao enviar log de erro:', error);
  }
};

/**
 * Envia um log de erro relacionado ao checkout
 * @param {string} errorMessage - Mensagem de erro
 * @param {string} step - Etapa do checkout onde o erro ocorreu
 * @param {Object} options - Opções adicionais
 */
export const logCheckoutError = async (errorMessage, step, options = {}) => {
  const clientData = JSON.parse(localStorage.getItem('userDataLogin') || '{}');
  
  await logError(
    errorMessage,
    `Checkout - ${step}`,
    {
      ...options,
      clientId: clientData.ID_DM001 || 'Não logado',
      url: window.location.href
    }
  );
};
